import { composeWithDevTools } from "@redux-devtools/extension";
import { createStore } from "redux";
import combinedReducers, { createReduxHistory, getEnhancers } from "./combineReducers";
const store = createStore(combinedReducers, composeWithDevTools(getEnhancers(false)));
export default store;
export const history = createReduxHistory(store);
